export default {
  getIsOnboardingModalVisible: (state) => state.isOnboardingModalVisible,
  getOnboardingModalTriggerOrigin: (state) => state.onboardingModalTriggerOrigin,
};
